<epay-page-content [pagetitle]="pagetitle">
  <div class="page-content-main box-panel shadow max-w max-gm" id="page-content-main">
    <div class="terms-panel" [innerHTML]="terms" [ngClass]="isMobile ? 'terms-panel-mobile' : ''">
    </div>
  </div>
</epay-page-content>
